import useIntegrationSettings from "common/datahooks/useIntegrationSettings";
import {
  ContentContainer,
  ContentHeader,
  PageTitle,
} from "common/layouts/WorkspaceLayout";
import type { InstalledIntegrationSettingsItem } from "common/types";

import { INTEGRATIONS_LIST } from "../constants";
import CrmIntegrationSettings from "./CrmIntegrationSettings";
import IntegrationConnect from "./IntegrationConnect";
import IntegrationItem from "./IntegrationItem";
import IntegrationSettings from "./IntegrationSettings";

import type { JSX } from "react";

export default function IntegrationsList() {
  const { integrationSettings } = useIntegrationSettings();

  return (
    <ContentContainer>
      <ContentHeader>
        <PageTitle />
      </ContentHeader>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3 p-4">
        {INTEGRATIONS_LIST.map(({ icon, title, description, ...rest }) => {
          let props:
            | { redirectUrl: string }
            | { settingsComponent: JSX.Element };

          if ("key" in rest) {
            if (!integrationSettings) {
              return (
                <IntegrationItem
                  key={title}
                  icon={icon}
                  title={title}
                  description={description}
                  isLoading
                />
              );
            }

            const settings = integrationSettings[rest.key];

            if (rest.key === "instantly" || rest.key === "smartlead") {
              let settingsComponent = <IntegrationConnect type={rest.key} />;

              if (settings) {
                settingsComponent =
                  rest.key === "instantly" ? (
                    <IntegrationSettings
                      type="instantly"
                      workspaceName={
                        (settings as { workspace_name: string }).workspace_name
                      }
                    />
                  ) : (
                    <IntegrationSettings
                      type="smartlead"
                      apiKey={(settings as { api_key: string }).api_key}
                    />
                  );
              }

              props = { settingsComponent };
            } else {
              props =
                "install_url" in settings
                  ? { redirectUrl: settings.install_url }
                  : {
                      settingsComponent: (
                        <CrmIntegrationSettings
                          settings={
                            settings as InstalledIntegrationSettingsItem
                          }
                          integrationKey={rest.key}
                        />
                      ),
                    };
            }
          } else {
            const { redirectUrl } = rest;

            props = {
              redirectUrl,
            };
          }

          return (
            <IntegrationItem
              key={title}
              icon={icon}
              title={title}
              description={description}
              {...props}
            />
          );
        })}
      </div>
    </ContentContainer>
  );
}
